import * as React from "react";

function SvgInventoryOutlined(props) {
  return <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 .055L2.724 7.289A4.178 4.178 0 00.25 11.094V37.75h37.5V11.094c0-1.64-.976-3.138-2.474-3.805l-.004-.004L19 .055zm0 4.557l14.583 6.482v22.49h-4.166V25.25H25.25v-8.333h-12.5v8.333H8.583v8.333H4.417V11.094L19 4.612zm-2.083 16.471h4.166v4.167h-4.166v-4.167zm-4.167 8.334h4.167v4.166H12.75v-4.166zm8.333 0h4.167v4.166h-4.167v-4.166z" /></svg>;
}

export default SvgInventoryOutlined;